<template>
  <Headline
    :title="title"
    image="contacts"
  ></Headline>
</template>
<script setup>
definePageMeta({
  title: 'Contactos',
  path: '/contactos',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>